import axios from 'axios';

const state = {
    typeGroups: [],
    userGroups: [],
    memberTypes: [],
    groupTypes: [],
    permissionTypes: [],
    suppliers: [],
    forms: [],
    genderTypes: [],
    applicationStatuses: [],
    fasApplicationStatuses: [],
    supplierStatuses: [],
    supplierTypes: [],
    supplierAccountTypes: [],
    states: [],
    templateTypes: [],
    systemUsers: [],
    taskTypes: [],
    taskStatuses: [],
    taskPriorities: [],
    taskProjects: [],
    communicationTypes: [],
    customFieldModels: []
};

const actions = {
    CLEAR_DATA({commit}){
        return new Promise((resolve, reject) => {
            commit('CLEAR_DATA');
            resolve(true);
        })
    },
    INIT_DATA({commit, dispatch}){
        //dispatch('GET_ROLES');
        //dispatch('GET_PERMISSIONS');
    },
    GET_GROUPS({commit}){
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            axios.get(process.env.VUE_APP_API_URL + '/groups?sortColumn=name&sortDir=asc').then(response => {
                commit('SET_GROUPS', response.data, 'userGroups');
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_PERMISSIONS({commit}){
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            axios.get(process.env.VUE_APP_API_URL + '/permissions?sortColumn=name&sortDir=asc').then(response => {
                commit('SET_PERMISSIONS', response.data, 'permissions');
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_PERMISSION_TYPES({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'permission-types' }, active: { value: 1}},
                    sortColumn: 'name',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_PERMISSION_TYPES', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_MEMBER_TYPES({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'member-types' }, active: { value: 1}},
                    sortColumn: 'ordering',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_MEMBER_TYPES', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_GENDER_TYPES({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'genders' }, active: { value: 1}},
                    sortColumn: 'name',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_GENDER_TYPES', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_TYPE_GROUPS({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types/groups').then(response => {
                commit('SET_TYPE_GROUPS', response.data);
                resolve(response);
            }).catch(error => {
                    reject(error);
            });
        })
    },
    GET_GROUP_TYPES({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'group-types' }, active: { value: 1}},
                    sortColumn: 'name',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_GROUP_TYPES', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_SUPPLIER_TYPES({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'supplier-types' }, active: { value: 1}},
                    sortColumn: 'name',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_SUPPLIER_TYPES', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_SUPPLIER_ACCOUNT_TYPES({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'supplier-account-types' }, active: { value: 1}},
                    sortColumn: 'name',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_SUPPLIER_ACCOUNT_TYPES', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_SUPPLIERS({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/suppliers', {
                params: {
                    sortColumn: 'name',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_SUPPLIERS', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_APPLICATION_FORMS({commit}){
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            axios.get(process.env.VUE_APP_API_URL + '/application-forms', {
                params: {
                    sortColumn: 'ordering',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_APPLICATION_FORMS', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_APPLICATION_STATUSES({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'application-statuses' }, active: { value: 1}},
                    sortColumn: 'ordering',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_APPLICATION_STATUSES', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_FAS_APPLICATION_STATUSES({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'fas-application-statuses' }, active: { value: 1}},
                    sortColumn: 'ordering',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_FAS_APPLICATION_STATUSES', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_SUPPLIER_STATUSES({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'supplier-statuses' }, active: { value: 1}},
                    sortColumn: 'ordering',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_SUPPLIER_STATUSES', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_STATES({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'states' }, active: { value: 1}},
                    sortColumn: 'ordering',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_STATES', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_TEMPLATE_TYPES({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'template-types' }, active: { value: 1}},
                    sortColumn: 'name',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_TEMPLATE_TYPES', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_SYSTEM_USERS({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/users', {
                params: {
                    filters: { type: 'system' },
                    sortColumn: 'last',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_SYSTEM_USERS', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_TASK_TYPES({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'task-types' }, active: { value: 1}},
                    sortColumn: 'name',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_TASK_TYPES', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_TASK_STATUSES({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'task-statuses' }, active: { value: 1}},
                    sortColumn: 'ordering',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_TASK_STATUSES', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_TASK_PRIORITIES({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'task-priorities' }, active: { value: 1}},
                    sortColumn: 'ordering',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_TASK_PRIORITIES', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_TASK_PROJECTS({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'projects' }},
                    sortColumn: 'ordering',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_TASK_PROJECTS', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_COMMUNICATION_TYPES({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'communication-types' }, active: { value: 1}},
                    sortColumn: 'name',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_COMMUNICATION_TYPES', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    GET_CUSTOM_FIELD_MODELS({ commit }){
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + '/types', {
                params: {
                    filters: { group: {name: 'group', value: 'custom-field-models' }},
                    sortColumn: 'name',
                    sortDir: 'ASC'
                }
            }).then(response => {
                commit('SET_CUSTOM_FIELD_MODELS', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
}

const mutations = {
    SET_GROUPS(state, payload){
        state.userGroups = payload;
    },
    SET_PERMISSIONS(state, payload){
        state.permissions = payload;
    },
    SET_PERMISSION_TYPES(state, payload){
        state.permissionTypes = payload;
    },
    SET_MEMBER_TYPES(state, payload){
        state.memberTypes = payload;
    },
    SET_GENDER_TYPES(state, payload){
        state.genderTypes = payload;
    },
    SET_TYPE_GROUPS (state, payload){
        state.typeGroups = payload;
    },
    SET_GROUP_TYPES (state, payload){
        state.groupTypes = payload;
    },
    SET_SUPPLIER_TYPES (state, payload){
        state.supplierTypes = payload;
    },
    SET_SUPPLIER_ACCOUNT_TYPES (state, payload){
        state.supplierAccountTypes = payload;
    },
    SET_SUPPLIERS (state, payload){
        state.suppliers = payload;
    },
    SET_COMPONENTS (state, payload){
        state.components = payload;
    },
    SET_COMPONENT_CATEGORIES (state, payload){
        state.componentCategories = payload;
    },
    SET_APPLICATION_FORMS (state, payload){
        state.forms = payload;
    },
    SET_APPLICATION_STATUSES (state, payload){
        state.applicationStatuses = payload;
    },
    SET_FAS_APPLICATION_STATUSES (state, payload){
        state.fasApplicationStatuses = payload;
    },
    SET_SUPPLIER_STATUSES (state, payload){
        state.supplierStatuses = payload;
    },
    SET_STATES (state, payload){
        state.states = payload;
    },
    CLEAR_DATA: (state) => {
        state.typeGroups = [];
        state.groups = []
        state.memberTypes = []
        state.groupTypes = []
        state.permissionTypes = []
        state.suppliers = []
        state.forms = []
        state.genderTypes = []
        state.applicationStatuses = []
        state.fasApplicationStatuses = []
        state.supplierStatuses = []
        state.supplierTypes = []
        state.supplierAccountTypes = []
        state.states = []
    },
    SET_TEMPLATE_TYPES (state, payload){
        state.templateTypes = payload;
    },
    SET_SYSTEM_USERS (state, payload){
        state.systemUsers = payload;
    },
    SET_TASK_TYPES (state, payload){
        state.taskTypes = payload;
    },
    SET_TASK_STATUSES (state, payload){
        state.taskStatuses = payload;
    },
    SET_TASK_PRIORITIES (state, payload){
        state.taskPriorities = payload;
    },
    SET_TASK_PROJECTS (state, payload){
        state.taskProjects = payload;
    },
    SET_COMMUNICATION_TYPES (state, payload){
        state.communicationTypes = payload;
    },
    SET_CUSTOM_FIELD_MODELS (state, payload){
        state.customFieldModels = payload;
    }
}

const getters = {
    typeGroups: state => {
        return state.typeGroups;
    },
    userGroups: state => {
        return state.userGroups;
    },
    groupTypes: state => {
        return state.groupTypes;
    },
    permissionTypes: state => {
        return state.permissionTypes;
    },
    memberTypes: state => {
        return state.memberTypes;
    },
    genderTypes: state => {
        return state.genderTypes;
    },
    supplierTypes: state => {
        return state.supplierTypes;
    },
    supplierAccountTypes: state => {
        return state.supplierAccountTypes;
    },
    suppliers: state => {
        return state.suppliers;
    },
    forms: state => {
        return state.forms;
    },
    applicationStatuses: state => {
        return state.applicationStatuses;
    },
    fasApplicationStatuses: state => {
        return state.fasApplicationStatuses;
    },
    supplierStatuses: state => {
        return state.supplierStatuses;
    },
    states: state => {
        return state.states;
    },
    templateTypes: state => {
        return state.templateTypes;
    },
    systemUsers: state => {
        return state.systemUsers;
    },
    taskTypes: state => {
        return state.taskTypes;
    },
    taskPriorities: state => {
        return state.taskPriorities;
    },
    taskStatuses: state => {
        return state.taskStatuses;
    },
    taskProjects: state => {
        return state.taskProjects;
    },
    communicationTypes: state => {
        return state.communicationTypes;
    },
    customFieldModels: state => {
        return state.customFieldModels;
    }
}

const module = {
    state,
    mutations,
    getters,
    actions
};

export default module;
